import { trackError } from '@billy/track-error'

import { getOnboardingStepFlow } from '../constants/onboardingStepFlow'
import { OnboardingSetupStep } from '../types'

type GetNextStepAction = 'continue' | 'skip'
type GetNextStepResult = { type: 'step'; step: OnboardingSetupStep } | { type: 'finish' }

const finishResult: GetNextStepResult = { type: 'finish' }

interface GetNextStepParams {
  action: GetNextStepAction
  currentStep: OnboardingSetupStep
  isExtendedQuestionnaire: boolean
}

export const getOnboardingNextStep = ({
  action,
  currentStep,
  isExtendedQuestionnaire,
}: GetNextStepParams): GetNextStepResult => {
  const stepConfig = getOnboardingStepFlow(isExtendedQuestionnaire)[currentStep]

  if (!stepConfig) {
    trackError(`No step flow config found for step "${currentStep}"`)
    return finishResult
  }

  const targetStep = stepConfig[action]

  return targetStep === 'FINISH' ? finishResult : { type: 'step', step: targetStep }
}
